import React from "react";
import { PlainModalOverlay } from "../../UI/Modal/Modal";
import { ButtonOutlineGreenWithDiffStyle, ButtonSubmitGreen, ButtonThin } from "../../UI/Buttons/Buttons";
import { FaLinkedin } from 'react-icons/fa';
import { FaLongArrowAltLeft } from "react-icons/fa";
import { FaCopy } from "react-icons/fa6";
import Alert from '@mui/material/Alert';
import ResumeSelectList from "../ResumeSelectList";

const InternalAppJobModal = React.memo(({
    closeModalsAndReset,
    linkedinUrl,
    companyUrl,
    applicants,
    allResumes,
    activeResIndex,
    handleResumeSelect,
    handleResumePreview,
    handleInternalJobModalSubmit,
    handleApplicationLinkCopy
}) => {
    return (
        <PlainModalOverlay>
            <div style={{ width: '100%', textAlign: 'center' }}>
                <div className='prev-page' onClick={closeModalsAndReset}>
                    <FaLongArrowAltLeft />
                </div>
                <h4 style={{ color: '#3E8F93', marginBottom: 10 }}>Apply for Position</h4>
                {applicants > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10, color: 'gray', fontSize: '.85rem' }}>
                        <span style={{ marginRight: 6 }}>Applicants:</span> {applicants}
                    </div>
                )}
                <Alert severity="info" sx={{ mb: 2, fontSize: '.8rem' }}>
                    Choose how you'd like to apply and a related resume. I'll automatically optimize it for this job, auto-answer the application form questions, then let you preview and submit.
                </Alert>
                <ResumeSelectList
                    label="Select Resume"
                    resumes={allResumes}
                    selectedIndex={activeResIndex}
                    onSelectResume={(idx) => handleResumeSelect(idx)}
                    onPreviewResume={handleResumePreview}
                />
                <div style={{ margin: '20px 0 10px 0', fontWeight: 600 }}>Application Methods</div>
                {companyUrl && (                
                    <div style={{ margin: '10px 0 10px 0'}}>
                        <ButtonSubmitGreen
                            style={{ marginBottom: 10, marginTop: '10px', width: '100%', maxWidth: 300, background: '#3E8F93' }}
                            onClick={() => handleInternalJobModalSubmit('company-site')}
                        >
                            Auto Apply via Company Website
                        </ButtonSubmitGreen>
                    </div>
                )}
                {linkedinUrl && (
                    <ButtonOutlineGreenWithDiffStyle
                        onClick={() => handleInternalJobModalSubmit('linkedin')}
                    >
                        <FaLinkedin style={{ fontSize: '1.2rem' }} /> Auto Apply via LinkedIn
                    </ButtonOutlineGreenWithDiffStyle>
                )}

                {!linkedinUrl && !companyUrl && (
                    <Alert severity="warning" sx={{ mt: 2 }}>
                        No direct application methods available for this position.
                    </Alert>
                )}
                <div>
                    <Alert sx={{ mb:1, mt:2, fontSize:'.8rem', fontWeight:600, textAlign:'left' }} severity="warning">
                        Or, you can apply manually below, but this method is not recommended and does not give the guarantees Bubble Ai provides with tailoring your application:
                    </Alert>
                    <ButtonThin
                        fontSize='.6rem' 
                        border='2px solid #987070' 
                        width={'100%'} 
                        height='35px' 
                        color='black'
                        onClick={() => handleApplicationLinkCopy(companyUrl || linkedinUrl)}
                    >
                        <FaCopy style={{color: "#987070", fontSize: ".9rem"}} />&nbsp;&nbsp; Copy Application Link
                    </ButtonThin>
                </div>
            </div>
        </PlainModalOverlay>
    );
});

export default InternalAppJobModal;